module.exports = __webpack_public_path__ + "img/landing_mtn.95fd2695.jpg";